/**
 * @generated SignedSource<<9469eadded70c80d9d1a54ba0b89c2bc>>
 * @relayHash 94cb55e27d7fa9b012bee6bcee0019c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a161d5f66ff1466b3ed138da9329ba390d344c3417406a1582cebd708496c160

import type { ConcreteRequest } from 'relay-runtime';
export type HelpCenterDraftPublishInput = {
  helpCenterAri: string;
};
export type migrationReviewActionBarPublishDraftHelpCenterChangesMutation$variables = {
  cloudId: string;
  input: HelpCenterDraftPublishInput;
};
export type migrationReviewActionBarPublishDraftHelpCenterChangesMutation$data = {
  readonly helpCenter: {
    readonly publishDraftHelpCenterChanges: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null;
      }>;
      readonly success: boolean;
    } | null;
  } | null;
};
export type migrationReviewActionBarPublishDraftHelpCenterChangesMutation = {
  response: migrationReviewActionBarPublishDraftHelpCenterChangesMutation$data;
  variables: migrationReviewActionBarPublishDraftHelpCenterChangesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "HelpCenterMutationApi",
    "kind": "LinkedField",
    "name": "helpCenter",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "HelpCenterDraftPublishPayload",
        "kind": "LinkedField",
        "name": "publishDraftHelpCenterChanges",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "migrationReviewActionBarPublishDraftHelpCenterChangesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "migrationReviewActionBarPublishDraftHelpCenterChangesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "a161d5f66ff1466b3ed138da9329ba390d344c3417406a1582cebd708496c160",
    "metadata": {},
    "name": "migrationReviewActionBarPublishDraftHelpCenterChangesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "715e57af3ff6ff4f1ffca7fc8a194fd8";

export default node;
